import { AMLS_COMMON, AMLS_TM_COMMON } from './globalConstants';

const TOKEN_ID = (localStorage && localStorage.getItem('id_token')) || '';

export const TM_COMMON_CONSTANTS = {
  BASE_URL: AMLS_TM_COMMON,
  HTTP_HEADERS: Object.freeze({
    'Content-Type': 'application/json',
    'X-HTTP-Method-Override': 'PUT',
    Authorization: `${TOKEN_ID}`
  }),
  PREVENTION_COMMON: AMLS_COMMON
};
